import Antecedents from './Step/Antecedents/Antecedents';
import Besoins from './Step/Besoins/Besoins';
import ConfirmationDevisContainer from './Step/ConfirmationDevis/ConfirmationDevisContainer';
import Coordonnees from './Step/Coordonnees/Coordonnees';
import EnvoiPiecesContainer from './Step/EnvoiPieces/EnvoiPiecesContainer';
import InformationsSouscripteurContainer from './Step/InformationsSouscripteur/InformationsSouscripteurContainer';
import RecontactContainer from './Step/InformationsSouscripteur/RecontactContainer';
import PaiementContainer from './Step/Paiement/PaiementContainer';
import Profil from './Step/Profil/Profil';
import RecapGPTContainer from './Step/RecapGPT/RecapGPTContainer';
import RecapitulatifContainer from './Step/Recapitulatif/RecapitulatifContainer';
import SignatureContainer from './Step/Signature/SignatureContainer';
import TarifContainer from './Step/Tarif/TarifContainer';
import ValidationContainer from './Step/Validation/ValidationContainer';
import Vehicule from './Step/Vehicule/Vehicule';
import {getTranslation} from "@amo/core/utils/index.js";
import {store} from '../../../redux/stores';

const buildRouteStep = (placeCoordonneesAfterTarif) => {
    let step = 0;
    const routes = [
        {
            step: step++,
            slug: 'votre-vehicule',
            title: getTranslation('step.vehicle'),
            main: ({ props, other }) => <Vehicule {...props} {...other} />,
        },
        {
            step: step++,
            slug: 'votre-profil',
            title: getTranslation('step.profil'),
            main: ({ props, other }) => <Profil {...props} {...other} />,
        },
        {
            step: step++,
            slug: 'vos-antecedents',
            title: getTranslation('step.history'),
            main: ({ props, other }) => <Antecedents {...props} {...other} />,
        },
        {
            step: step++,
            slug: 'vos-besoins',
            title: getTranslation('step.needes'),
            main: ({ props, other }) => <Besoins {...props} {...other} />,
        },
    ];

    const coordonneesRoute = {
        slug: 'vos-coordonnees',
        title: getTranslation('step.coordonnees'),
        main: ({ props, other }) => <Coordonnees {...props} {...other} />,
    };

    if (!placeCoordonneesAfterTarif) {
        routes.push({ step: step++, ...coordonneesRoute });
    }

    routes.push(
        {
            step: step++,
            slug: 'recap-gpt',
            title: 'Récapitulatif',
            main: ({ props, other }) => <RecapGPTContainer {...props} {...other} />,
        },
        {
            step: step++,
            slug: 'votre-tarif',
            title: getTranslation('step.prices'),
            main: ({ props, other }) => <TarifContainer {...props} {...other} />,
        },
    );

    if (placeCoordonneesAfterTarif) {
        routes.push({ step: step++, ...coordonneesRoute });
    }

    routes.push(
        {
            step: step++,
            slug: 'vos-infos',
            title: getTranslation('step.informations'),
            main: ({ props, other }) => <InformationsSouscripteurContainer {...props} {...other} />,
        },
        {
            step: step++,
            slug: 'recapitulatif',
            title: getTranslation('step.recap'),
            main: ({ props, other }) => <RecapitulatifContainer {...props} {...other} />,
        },
        {
            step: step++,
            slug: 'paiement',
            title: getTranslation('step.payment'),
            main: ({ props, other }) => <PaiementContainer {...props} {...other} />,
        },
        {
            step: step++,
            slug: 'validation',
            title: getTranslation('step.validation'),
            main: ({ props, other }) => <ValidationContainer {...props} {...other} />,
        },
        {
            step: step++,
            slug: 'signature',
            title: getTranslation('step.signature'),
            main: ({ props, other }) => <SignatureContainer {...props} {...other} />,
        },
        {
            step: step++,
            slug: 'envoi-des-pieces',
            title: getTranslation('step.sendDocument'),
            main: ({ props, other }) => <EnvoiPiecesContainer {...props} {...other} />,
        },
        {
            step: step++,
            slug: 'recontact',
            title: getTranslation('step.beRecontact'),
            main: ({ props, other }) => <RecontactContainer {...props} {...other} />,
        },
        {
            step: step++,
            slug: 'confirmation-devis',
            title: getTranslation('step.confirmQuote'),
            main: ({ props, other }) => <ConfirmationDevisContainer {...props} {...other} />,
        },
    );

    return routes;
};

export const getRouteStep = (typeMER) => buildRouteStep(['AppGPT', 'AgentConv'].includes(typeMER));

const getRouteStepFromStore = () => {
    const typeMER = store.getState()?.init?.data?.DemandeDevis?.TypeMER ?? null;
    return getRouteStep(typeMER);
};

const RouteStep = new Proxy([], {
    get(_target, prop) {
        const routes = getRouteStepFromStore();
        const value = routes[prop];
        return typeof value === 'function' ? value.bind(routes) : value;
    },
    has(_target, prop) {
        return prop in getRouteStepFromStore();
    },
    ownKeys() {
        return Reflect.ownKeys(getRouteStepFromStore());
    },
    getOwnPropertyDescriptor(_target, prop) {
        return Object.getOwnPropertyDescriptor(getRouteStepFromStore(), prop);
    },
});

export default RouteStep;
